// extracted by mini-css-extract-plugin
module.exports = {"posts":"tags-module--posts--3AMnX","tags":"tags-module--tags--2vhKA"};